import { StateCreator } from 'zustand';

import { NavigationPaneState } from './types/NavigationPaneState';

export const navigationPaneStore: StateCreator<NavigationPaneState> = (
  set,
) => ({
  drawerOpen: false,
  setDrawerOpen: (open: boolean) => {
    set({ drawerOpen: open });
  },
});
